/**
 * Highlight-to-translate dock.
 *
 * Currently a no-op: the dock previously called a Cloudflare Worker to
 * translate selected English on the fly. The worker and its TTS/translate
 * endpoints were removed when the project pivoted to a single-learner
 * design where the Darija explanation is baked into each slide. Kept as
 * a stub so main.ts and the dock element in index.html stay valid; we
 * may rewire this to surface inline glossary lookups later.
 */
export function attachHighlightTranslator(_root: HTMLElement): void {
  const dock = document.getElementById('translate-dock');
  if (dock) dock.hidden = true;
}
